import React from 'react';

import styles from './UserExperience.module.css';

interface UserExperienceBarProps {
  sectionCount: number;
  progression: number;
}

const UserExperienceBar = ({ progression, sectionCount }: UserExperienceBarProps): JSX.Element => {
  const rows = [];

  let prg = progression;
  for (let i = 0; i < sectionCount; i += 1) {
    let greenProgressionWidth = '0%';
    if (prg >= 10) {
      greenProgressionWidth = '100%';
    } else if (prg > 0) {
      greenProgressionWidth = `${prg * 10}%`;
    } else {
      greenProgressionWidth = '0%';
    }
    prg -= 10;

    if (i === 0) {
      rows.push(
        <div className={styles['first-bar-container']}>
          <div className={styles['first-bar-inner']} style={{ width: greenProgressionWidth }} />
        </div>,
      );
    } else if (i === sectionCount - 1) {
      rows.push(
        <div className={styles['last-bar-container']}>
          <div className={styles['last-bar-inner']} style={{ width: greenProgressionWidth }} />
        </div>,
      );
    } else {
      rows.push(
        <div className={styles['bar-container']}>
          <div className={styles['bar-inner']} style={{ width: greenProgressionWidth }} />
        </div>,
      );
    }
  }
  return <div className={styles['bar-outer-container']}>{rows}</div>;
};
export default UserExperienceBar;
